// Kurdish translations
export const ku: Record<string, string> = {
  'menu.dashboard': 'Panela Kontrolê',
  'menu.customers': 'Xerîdar',
  'menu.products': 'Berhemên',
  'menu.users': 'Bikarhêner',
  'menu.settings': 'Mîhengên',
  'menu.logout': 'Derketin',
  'dashboard.title': 'Panela Kontrolê',
  'dashboard.newOrder': 'Fermana nû',
  'order.title': 'Fermana nû',
  'order.customer': 'Xerîdar',
  'order.products': 'Berhemên',
  'order.total': 'Tevahî',
  'users.title': 'Bikarhêner',
  'users.name': 'Nav',
  'users.email': 'E-posta',
  'common.yes': 'Erê',
  'common.no': 'Na',
  'common.cancel': 'Betal bike',
  'common.save': 'Tomar bike',
  'common.search': 'Lêgerîn',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Têketin',
  'login.welcome': 'Bi xêr hatî, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'E-posta',
  'signup.phone': 'Têlefon',
  'menu.reportsAndAccounting': 'Rapor û Hesabdarî',
  'menu.systemAndCommunication': 'Sîstem û Ragihandin',
};